/**
 * Órdenes pendientes (`status=pendiente`). Reemplaza el placeholder de la ruta
 * `ROUTES.ordersPending`. Equivale a `orders.html` del SSR.
 */
import { OrdersListScreen } from "./OrdersListScreen";

export function OrdersPendingScreen() {
  return <OrdersListScreen status="pendiente" title="Órdenes pendientes" />;
}
